const _throttle = require('lodash.throttle');

let resizeListenerAdded = false;

function initializeDynamicColumns() {
    const dynamicColumnPanels = document.querySelectorAll('.faq-panel-dynamic-columns');

    dynamicColumnPanels.forEach(dynamicColumnPanel => {
        const maxColumns = 4;
        const dynamicColumns = Array.from({ length: maxColumns }, (_, i) =>
            dynamicColumnPanel.querySelector(`[data-dynamic-column="${i + 1}"]`)
        );

        function getColumnCount(windowWidth) {
            if (windowWidth < 640) return 1;
            if (windowWidth >= 640 && windowWidth < 1024) return 2;
            if (windowWidth >= 1024 && windowWidth < 1280) return 3;
            return 4; // Default to max columns
        }

        function distributeDynamicCards() {
            const dynamicCards = Array.from(dynamicColumnPanel.querySelectorAll('[data-dynamic-card-index]'));

            // Sort dynamic cards by data-dynamic-card-index
            dynamicCards.sort((a, b) => parseInt(a.dataset.dynamicCardIndex, 10) - parseInt(b.dataset.dynamicCardIndex, 10));

            // Get current column count based on window width
            const columnCount = getColumnCount(window.innerWidth);

            // Clear all columns
            dynamicColumns.forEach(column => column && (column.innerHTML = ''));

            // Distribute cards across the determined number of columns
            dynamicCards.forEach((card, index) => {
                const columnIndex = index % columnCount;
                dynamicColumns[columnIndex]?.appendChild(card);
            });
        }

        const throttledDistributeDynamicCards = _throttle(distributeDynamicCards, 200);

        // Add resize listener only once
        if (!resizeListenerAdded) {
            window.addEventListener('resize', () => {
                const windowWidth = window.innerWidth;

                // Check if media query changes column count
                const currentColumnCount = getColumnCount(windowWidth);
                const prevColumnCount = getColumnCount(window.prevWidth || 0);

                if (currentColumnCount !== prevColumnCount) {
                    throttledDistributeDynamicCards();
                }

                window.prevWidth = windowWidth;
            });
            resizeListenerAdded = true;
        }

        // Initial distribution of dynamic cards
        distributeDynamicCards();
    });
}

// Run on both DOMContentLoaded and window load
window.addEventListener('load', initializeDynamicColumns);
